namespace RioERP.Web.Enums {
    export enum FollowUpMode {
        Call = 1,
        chat = 2,
        email = 3,
        Other = 4
    }
    Serenity.Decorators.registerEnumType(FollowUpMode, 'RioERP.Web.Enums.FollowUpMode');
}
